import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { pushProductClick, pushProductImpressions } from '../utils/data-layer.js';
import { ProductRecommendation } from './ProductRecommendation.js';

const ProductRecommendationContainer = (props)=>{
    const { recommendation , position  } = props;
    const clickRef = React.useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handleRecommendationClick = React.useCallback(()=>{
        if (!clickRef.current) {
            pushProductClick(recommendation, position);
            clickRef.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(()=>{
        if (wasSeen) {
            pushProductImpressions(recommendation, position);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React.createElement(ProductRecommendation, swcHelpers.extends({
        ref: ref
    }, props, {
        onClick: handleRecommendationClick
    }));
};

export { ProductRecommendationContainer };
//# sourceMappingURL=ProductRecommendationContainer.js.map
